import { useNavigate } from 'react-router-dom';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

type Project = {
    projectName: string;
    description: string;
    budget: string;
    size: string;
    type: string;
    status: string;
    location: string;
    flat: string;
    services: string[];
    image1: string;
    image2: string;
};

function ProjectCard({ cardData }: { cardData: Project }) {
    const navigate = useNavigate();

    return (
        <div className="project-card">
            <div className="project-card-contents">
                <div className="project-card-image-container">
                    <LazyLoadImage
                        draggable={false}
                        src={cardData.image1}
                        alt={`${cardData.projectName}-Image`}
                        effect="blur"
                        width="100%"
                        height="100%"
                    />
                </div>
                <div className="project-card-description">
                    <h1>{cardData.projectName.toUpperCase()}</h1>
                    <p>{cardData.description}</p>
                    <button
                        className="project-card-learn-more-button"
                        onClick={() => {
                            navigate(`/Projects/${cardData.projectName.replace(/\s+/g, "-")}`, { state: cardData });
                            window.scrollTo({ top: 0 });
                        }}
                        aria-label="Learn more about the project"
                    >
                        Learn More
                    </button>
                </div>
            </div>
        </div>
    )
}

export default ProjectCard;